import { onBeforeUnmount, onMounted, ref, toValue } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router'

/*
 * Avisa antes de perder cambios sin guardar.
 *
 * - Navegación dentro de la app: bloquea la ruta y abre una confirmación propia
 *   (`isLeaveConfirmationOpen`); se resuelve con `confirmLeave` o `cancelLeave`.
 * - Recargar o cerrar la pestaña: diálogo nativo del navegador (`beforeunload`).
 *
 * `isDirty` puede ser un ref, un computed o un getter. Solo funciona en
 * componentes de ruta, que es donde vue-router ejecuta los guards de componente.
 */
export function useUnsavedChanges(isDirty) {
    const isLeaveConfirmationOpen = ref(false)
    let resolvePendingNavigation = null

    const answer = (canLeave) => {
        isLeaveConfirmationOpen.value = false
        resolvePendingNavigation?.(canLeave)
        resolvePendingNavigation = null
    }

    const confirmNavigation = () => {
        if (!toValue(isDirty)) return true

        // Si ya había una navegación pendiente, se cancela en favor de la nueva.
        resolvePendingNavigation?.(false)
        isLeaveConfirmationOpen.value = true
        return new Promise((resolve) => {
            resolvePendingNavigation = resolve
        })
    }

    const onBeforeUnload = (event) => {
        if (!toValue(isDirty)) return
        event.preventDefault()
        event.returnValue = ''
    }

    onBeforeRouteLeave(confirmNavigation)
    onBeforeRouteUpdate(confirmNavigation)
    onMounted(() => window.addEventListener('beforeunload', onBeforeUnload))
    onBeforeUnmount(() => window.removeEventListener('beforeunload', onBeforeUnload))

    return {
        isLeaveConfirmationOpen,
        confirmLeave: () => answer(true),
        cancelLeave: () => answer(false),
    }
}
